import './assets/styles/global.css';

// Import firebase service
import './firebase';

// Import Cookie Consent Service
import CookieConsentVue from './CookieConsentVue';

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { createVfm } from 'vue-final-modal'
import 'vue-final-modal/style.css'

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// Import specific icons
import { faHome, faUser, faCheckCircle, faFileLines, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { 
    faFacePersevering, 
    faPlateUtensils, 
    faPlus, faPenToSquare, 
    faTrash, 
    faEllipsis, 
    faFilePdf,
    faBreadLoaf,
    faMemoCircleCheck,
    faCircleCheck,
    faCarrot,
    faFiles,
    faCirclePlus,
    faTrophy,
    faFaceHandPeeking,
    faChevronRight,
    faArrowLeftLong,
    faXmark,
    faPen,
    faRightFromBracket,
    faChevronLeft,
    faFile,
    faHouse,
    faBars,
    faBoxArchive,
    faSeedling,
    faBullseyeArrow,
    faBan,
    faBowlFood as fasBowlFood,
    faHandWave
} from "@fortawesome/pro-solid-svg-icons";

import { 
    faBowlFood as falBowlFood,
    faMemoPad,
    faCalendarDays,
    faHatChef,
    faFaceTired,
} from "@fortawesome/pro-light-svg-icons";

const vfm = createVfm()

import { onIdTokenChanged } from 'firebase/auth';
import { auth } from './firebase';

onIdTokenChanged(auth, async (user) => {
  if (user) {
    try {
      // Force refresh to ensure you have the latest token
      const token = await user.getIdToken(true);
      store.commit('setUser', user);
      store.commit('setIdToken', token);
    } catch (error) {
      console.error('Failed to refresh token:', error);
      // If token refresh fails, logout the user
      store.commit('clearAuth');
      await auth.signOut();
    }
  } else {
    store.commit('clearAuth');
  }
});


// Add icons to the library
library.add(
    faHandWave,
    faHome, 
    faUser, 
    faCheckCircle, 
    faFacePersevering, 
    faPlateUtensils, 
    faPlus, 
    faPenToSquare, 
    faTrash, 
    faEllipsis, 
    faFilePdf,
    faBreadLoaf,
    faMemoCircleCheck,
    faFileLines,
    faCircleCheck,
    faCarrot,
    faFiles,
    faCirclePlus,
    faTrophy,
    faFaceHandPeeking,
    fasBowlFood,
    falBowlFood,
    faChevronRight,
    faMemoPad,
    faArrowLeftLong,
    faCalendarDays,
    faHatChef,
    faFaceTired,
    faXmark,
    faPen,
    faRightFromBracket,
    faChevronLeft,
    faMagnifyingGlass,
    faFile,
    faHouse,
    faBars,
    faBoxArchive,
    faSeedling,
    faBullseyeArrow,
    faBan
);


createApp(App).use(store).use(router).use(vfm).use(CookieConsentVue, {
  categories: {
    necessary: {
      enabled: true,
      readOnly: true,
    },
    analytics: {
      enabled: false,
    },
  },
  guiOptions: {
    consentModal: {
      layout: 'cloud',
      position: 'bottom center',
      flipButtons: false,
      equalWeightButtons: true
    },
  },

  language: {
    default: 'en',
    translations: {
      en: {
        consentModal: {
          title: 'We use cookies',
          description: 'This website uses cookies for analytics.',
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject all',
          showPreferencesBtn: 'Manage preferences',
        },
        preferencesModal: {
          title: 'Manage cookie preferences',
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject all',
          savePreferencesBtn: 'Save preferences',
          closeIconLabel: 'Close',
          sections: [
            {
              title: 'Necessary cookies',
              description: 'Required for the website to function properly.',
              linkedCategory: 'necessary',
            },
            {
              title: 'Analytics cookies',
              description: 'Used to track page views and usage.',
              linkedCategory: 'analytics',
            },
          ],
        },
      },
    },
  },
}).component('font-awesome-icon', FontAwesomeIcon).mount('#app');
